/* eslint-disable react/prop-types */
/* eslint-disable import/prefer-default-export */
import React from 'react'

import { Subway as SubwayGeneric } from 'components/generic/dropdown/Subway'

export function Subway(props) {
  const { loading, value, onChange, options } = props

  return <SubwayGeneric loading={loading} value={value} onChange={onChange} options={options} />
}
